import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

const map = {
  plans: [
    { value: 'pro', text: 't(Pro)' },
    { value: 'essentials', text: 't(Essentials)' }
  ],
  addons: [
    { value: 'logo', text: 't(Logo)' },
    { value: 'brand', text: 't(Brand)' },
    { value: 'singlepage', text: 't(Single Page Website)' },
    { value: 'sevenpage', text: 't(Seven Page Website)' }
  ]
}

class Edit extends React.Component {

  static contextTypes = {
    provider: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    plans: PropTypes.array,
    signup_page: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { plans, signup_page } = this.props
    const { provider } = this.context
    return {
      title: 't(Edit Signup Page)',
      method: 'PATCH',
      endpoint: `/api/admin/truevail/admin/signup_pages/${signup_page.id}/edit`,
      action: `/api/admin/truevail/admin/signup_pages/${signup_page.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)', 
              name: 'title', 
              type: 'textfield', 
              required: true 
            },
            { 
              label: 't(URL)', 
              name: 'permalink', 
              type: 'permalinkfield', 
              prefix: '/signup', 
              required: true, 
              host: provider.admin_host, 
              placeholder: '/path/to/signup' 
            }
          ]
        },
        {
          label: 't(Details)',
          fields: [
            ...map.plans.map(plan => ({
              label: plan.text,
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    {
                      label: 't(Monthly Plan)',
                      name: `config.${plan.value}.monthly_plan_id`,
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('month') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    },
                    {
                      label: 't(Yearly Plan)',
                      name: `config.${plan.value}.yearly_plan_id`,
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('year') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    }
                  ]
                }
              ]
            })),
            ...map.addons.map(addon => ({
              label: addon.text,
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    { label: 't(Price)', 
                      name: `config.${addon.value}.price`, 
                      type: 'moneyfield', 
                      required: true
                    },
                    { 
                      label: 't(Discounted Price)', 
                      name: `config.${addon.value}.discount_price`, 
                      type: 'moneyfield'
                    }
                  ]
                }
              ]
            })),
            {
              label: 't(Setup Fee)',
              name: 'config.setup_fee',
              type: 'moneyfield',
              required: true,
              defaultValue: 0.00
            },
            {
              label: 't(Free Setup)',
              name: 'config.free_setup',
              type: 'checkbox',
              defaultValue: true
            },
            {
              label: 't(Trial Length)',
              name: 'config.trial_length',
              type: 'numberfield',
              required: true,
              defaultValue: 1
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(result) {
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  plans: '/api/admin/subscriptions/services/3/plans'
})

export default Container(mapResources)(Edit)
